package uz.mint.frontend.pages.en

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.data.add
import com.varabyte.kobweb.core.init.InitRoute
import com.varabyte.kobweb.core.init.InitRouteContext
import com.varabyte.kobweb.core.layout.Layout
import uz.mint.frontend.components.layouts.PageLayoutData
import uz.mint.frontend.components.sections.OrderDetailPage
import uz.mint.frontend.i18n.Locale
import uz.mint.frontend.i18n.accountStringsFor

/** One purchase in full — English, at /en/order. The reference travels as `?ref=`. */
private val LOCALE = Locale.EN

@InitRoute
fun initEnOrderRoutePage(ctx: InitRouteContext) {
    val account = accountStringsFor(LOCALE)
    ctx.data.add(PageLayoutData(account.orderMetaTitle, LOCALE, account.orderMetaDescription))
}

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun EnOrderRoutePage() {
    OrderDetailPage(LOCALE)
}
